import { AccountProfileScreen } from '@/components/profile/AccountProfileScreen';

export function AccountViewPage() {
  return <AccountProfileScreen />;
}
